import React from "react";
import { colors, resolveColor } from "utils/styles";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Stack from "react-bootstrap/Stack";
import renderItem from "utils/renderItem";
import { valueOrDefault } from "utils/helpers";

export default function CenteredContainer(props) {
	const fields = props.data?.fields;

	const isContainer = fields?.isContainer ? fields?.isContainer : false;

	const containerBreakpoints = fields?.columnBreakpoints ? fields?.columnBreakpoints : {};

	const elementClasses = fields?.elementClasses ? fields?.elementClasses : false;
	const containerClasses = fields?.containerClasses ? fields?.containerClasses : " ";

	const outerBackgroundColor = fields.outerBackgroundColor
		? resolveColor(fields.outerBackgroundColor)
		: "transparent";

	const lowerOuterBackgroundColor = fields.lowerOuterBackgroundColor
		? resolveColor(fields.lowerOuterBackgroundColor)
		: false;

	const lowerBackgroundHeight = fields.lowerBackgroundHeight ? fields.lowerBackgroundHeight : "0";

	const backgroundImg =
		fields?.backgroundImage?.fields?.file?.url !== undefined ? fields?.backgroundImage?.fields?.file?.url : false;
	let backGroundImgWidth = fields?.backgroundImage?.fields?.file?.details?.image?.width;
	let backGroundImgHeight = fields?.backgroundImage?.fields?.file?.details?.image?.height;

	const backgroundImagePosition = fields?.backgroundImagePosition || "inherit";
	const backgroundImagePositionX = fields?.backgroundImagePositionX;
	const backgroundImagePositionY = fields?.backgroundImagePositionY;
	const bottomPadding = fields?.paddingBottom !== undefined ? fields?.paddingBottom : 0;
	const darkBackgroundImage = fields?.darkBackgroundImage ? fields?.darkBackgroundImage : false;
	const hashLink = fields?.hashLink;
	const innerBottomPadding = fields?.innerBottomPadding !== undefined ? fields?.innerBottomPadding : 0;
	const innerTopPadding = fields?.innerTopPadding !== undefined ? fields?.innerTopPadding : 0;
	const isWideContainer = fields?.isWideContainer ? fields?.isWideContainer : false;

	const lightBackgroundImage = fields?.lightBackgroundImage ? fields?.lightBackgroundImage : false;
	const lightenOrDarken = darkBackgroundImage || lightBackgroundImage;
	const lightOrDark = darkBackgroundImage ? "0,0,0," : lightBackgroundImage ? "255,255,255," : false;

	const moveUp = fields?.moveUp;
	const topPadding = fields?.paddingTop !== undefined ? fields?.paddingTop : 0;

	const flexDirection = fields?.flexDirection === "vertical" ? "column" : false; // fields?.flexDirection === "horizontal" ? "row" : "row";
	const justify = valueOrDefault(fields?.horizontalAlign, "start");
	const verticalAlign = valueOrDefault(fields?.verticalAlign, "inherit");
	const alignContent = fields?.fields?.alignContent || false;
	const alignSelf = fields?.alignSelf !== undefined ? fields?.alignSelf : false;
	const outerWrapperClasses = fields?.outerWrapperClass || "";
	const zIndex = fields?.zIndex !== undefined ? fields?.zIndex : 1;

	const allOuterWrapperClasses = `outerWrapper CCC flex-grow-1 ${
		moveUp ? "moveUp" : ""
	} w-100 d-flex ${outerWrapperClasses}`;
	const sectionContainerClasses = `g-0 d-flex
	${isContainer ? `container-${isContainer}` : isWideContainer ? `wide-container-${isWideContainer}` : " "}`;

	return (
		<div className={allOuterWrapperClasses}>
			{/* Only show lower background if color is specified */}
			{lowerOuterBackgroundColor && <div className=" lowerBackground"></div>}
			<Container fluid className={sectionContainerClasses}>
				<section
					id={hashLink}
					className={`containerSection  ${containerClasses} w-100  row g-0  ${
						flexDirection ? `flex-${flexDirection}` : ""
					} ${justify ? `justify-content-${justify}` : " "}
					${verticalAlign ? `align-items-${verticalAlign}` : " "}
					${alignContent ? `align-content-${alignContent}` : ""}
					${alignSelf ? `align-self-${alignSelf}` : ""}
					`}
				>
					{/* <Row className={``}> */}
					{fields?.elements?.length > 0 &&
						fields?.elements.map((element) => {
							const key = element.sys.id;
							const model = element?.sys?.contentType?.sys.id;

							if (model === "content") {
								//Content component needs a little help passing the alignment down.
								if (element.fields.contentClasses) {
									if (
										justify &&
										!element.fields.contentClasses.includes(`justify-content-${justify}`)
									) {
										element.fields.contentClasses += ` justify-content-${justify} `;
									}
								}
							}

							let columnClasses = `cc-el d-flex ${justify ? ` justify-content-${justify} ` : ""} `;

							if (elementClasses) {
								columnClasses += ` ${elementClasses} `;
							}
							return (
								<Col {...containerBreakpoints} className={columnClasses} key={key}>
									{renderItem(element)}
								</Col>
							);
						})}
					{/* </Row> */}
				</section>
			</Container>

			<style jsx>{`
				.lowerBackground {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					top: ${lowerBackgroundHeight}%;
					background: ${lowerOuterBackgroundColor};
					z-index: -1;
				}

				.outerWrapper {
					background: ${outerBackgroundColor};
					z-index: ${zIndex};
					padding-top: ${topPadding}em;

					padding-bottom: ${bottomPadding}em;
					position: relative;
					background-image: ${backgroundImg
						? `${
								lightenOrDarken
									? `linear-gradient(rgba(${lightOrDark} ${lightenOrDarken}), rgba(${lightOrDark} ${lightenOrDarken})),`
									: ""
						  } url(${backgroundImg}?fm=webp)` //?w=1500&fit=scale
						: "none"};
					background-size: cover;
					background-repeat: no-repeat;
					background-position: ${backgroundImagePositionX !== undefined &&
					backgroundImagePositionY !== undefined
						? `${backgroundImagePositionX}% ${backgroundImagePositionY}%`
						: backgroundImagePosition};
				}
				.containerSection {
					background: ${resolveColor(fields?.backgroundColor)};
					padding-bottom: ${innerBottomPadding}em;
					padding-top: ${innerTopPadding}em;
				}

				.moveUp {
					margin-top: ${moveUp * -1}em;
				}
			`}</style>
		</div>
	);
}
